import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { envUrl } from '../app/services/environment/EnvironmentService';
import runtimeConfig from './runtimeConfig';
import AccountPage from '../app/account/AccountPageContainer';
import AccountDetailsPage from '../app/account/details/AccountDetailsPageComponent';
import AccountAddressesPage from '../app/account/addresses/AccountAddressesPageComponent';

const componentMap = {
  AccountDetailsPage,
  AccountAddressesPage,
};

const AccountRoutes = ({ componentMapOverride }) => {
  const pages = componentMapOverride ? componentMapOverride(componentMap) : componentMap;

  return (
    <Route
      path={envUrl('/')}
      render={() => (
        <AccountPage
          accountDetailsPath={envUrl('/account/details')}
          accountAddressesPath={envUrl('/account/addresses')}
        >
          {(childProps) => (
            <Switch>
              <Route
                path={envUrl('/account/details')}
                render={() => <pages.AccountDetailsPage account={childProps.account} actions={childProps.actions} />}
                runtimeConfig={runtimeConfig}
              />
              <Route
                path={envUrl('/account/addresses')}
                render={() => <pages.AccountAddressesPage account={childProps.account} actions={childProps.actions} />}
                runtimeConfig={runtimeConfig}
              />
              <Redirect to={envUrl('/account/details')} />
            </Switch>
          )}
        </AccountPage>
      )}
      runtimeConfig={runtimeConfig}
    />
  );
};

export default AccountRoutes;
